/** Calendar colour as round swatches (radio group): calendars, categories and the colour of one event. */
import { useI18n, type MessageKey } from '@platform/i18n';
import { CALENDAR_COLOR_CLASSES, CALENDAR_COLORS, cn, type CalendarColor } from '@platform/ui';
import { CheckIcon, XIcon } from 'lucide-react';

export function ColorChoice({ label, value, onChange, small, noneLabel }: { label: string; value: CalendarColor | null; onChange: (color: CalendarColor | null) => void; small?: boolean; noneLabel?: string }) {
  const { t } = useI18n();
  const size = small ? 'size-6' : 'size-8';
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {noneLabel && (
        <button
          type="button"
          role="radio"
          aria-checked={value === null}
          aria-label={noneLabel}
          title={noneLabel}
          onClick={() => onChange(null)}
          className={cn('flex items-center justify-center rounded-full border-2 bg-background text-muted-foreground outline-offset-2 focus-visible:outline-2 focus-visible:outline-ring', size, value === null && 'ring-2 ring-ring ring-offset-2 ring-offset-background')}
        >
          <XIcon className="size-3.5" />
        </button>
      )}
      {CALENDAR_COLORS.map((color) => (
        <button
          key={color}
          type="button"
          role="radio"
          aria-checked={value === color}
          aria-label={t(`webmail.calendar.colors.${color}` as MessageKey)}
          title={t(`webmail.calendar.colors.${color}` as MessageKey)}
          onClick={() => onChange(color)}
          className={cn('flex items-center justify-center rounded-full border-2 text-white outline-offset-2 focus-visible:outline-2 focus-visible:outline-ring', size, CALENDAR_COLOR_CLASSES[color].swatch, value === color && 'ring-2 ring-ring ring-offset-2 ring-offset-background')}
        >
          {value === color && <CheckIcon className="size-3.5" />}
        </button>
      ))}
    </div>
  );
}
